/**
 * Owner: Masa Bayu
 * File: bka-adam-types.ts
 * Date:Time: 2026-09-22 18:00
 * Description: BKA ADAM proposal types — proposal-only · never QXW mutate authority.
 */
/** Feature flag — ADAM Add Book proposals under ADAM BUILD AUTH. */
export const BKA_ADAM_FEATURE_FLAG = Object.freeze({
    id: 'bka.adam.proposal_integration',
    defaultEnabledInProduction: false,
    wave: 'adam',
    path: 'proposal',
    proposalOnly: true,
    adapterGate: 'ADAM-BUILD-AUTH',
    mayMutateQxwDirectly: false,
    mayPublish: false,
    doc03Undisturbed: true,
});
export const BKA_ADAM_PROPOSAL_STATUSES = [
    'pending',
    'accepted',
    'rejected',
    'superseded',
    'failed',
];
//# sourceMappingURL=bka-adam-types.js.map